import { createContext, useContext, useState } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    birth_date: "",
    email: "",
    password: "",
    phone: "",
    designation: "",
    department: "",
    role: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    pincode: "",
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [pincodeData, setPincodeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPincode, setSelectedPincode] = useState(null);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");

  // all user
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [allusersArr, setAllUsersArr] = useState([]);
  const [isNextPage, setIsNextPage] = useState(false);
  const [isPrevPage, setIsPrevPage] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  return (
    <UserContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        formValues,
        setFormValues,
        pincodeData,
        setPincodeData,
        loading,
        setLoading,
        selectedPincode,
        setSelectedPincode,
        city,
        setCity,
        state,
        setState,
        searchQuery,
        setSearchQuery,
        totalPageCount,
        setTotalPageCount,
        currentPage,
        setCurrentPage,
        allusersArr,
        setAllUsersArr,
        isNextPage,
        setIsNextPage,
        isPrevPage,
        setIsPrevPage,
        selectedUser,
        setSelectedUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  return useContext(UserContext);
};
